import { render } from "./RecordListDialog.vue?vue&type=template&id=ae9a28a6"
import script from "./RecordListDialog.vue?vue&type=script&lang=js"
export * from "./RecordListDialog.vue?vue&type=script&lang=js"

import exportComponent from "F:\\yiban\\WebProject\\yimeng-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__